"use strict";

var _require = require('idb-keyval'),
    set = _require.set,
    get = _require.get,
    del = _require.del;

module.exports = {
  readCache: get,
  writeCache: set,
  deleteCache: del,
  checkCache: function checkCache(path) {
    return get(path).then(function (v) {
      return typeof v !== 'undefined';
    });
  }
};